import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { DefaultFormFields, FormControl, FormController } from '@insurancemenu/imenu-components-lib/dist/utils/forms';
import { RatesOverride } from 'types/productServiceV2';
import { ProductRatesForm } from './productRatesForm';
import { OverrideRatesProduct } from './types';

export interface RatesOverriderDelegateProps {
  products: OverrideRatesProduct[];
}

export type DiscountFormController = FormController<DiscountFormFields>;

interface DiscountFormFields extends DefaultFormFields {
  discount: FormControl<number>;
}

export class RatesOverriderDelegate {
  public rateForms: ProductRatesForm[] = [];
  public discountForm: DiscountFormController = new FormController<DiscountFormFields>(
    {
      discount: new FormControl<number>(0, {
        optional: true,
        customValidations: [
          {
            check: (value: number): boolean => Number(value) >= 1 && Number(value) <= 99.9,
            msg: 'Only values between 1 and 99.9 are allowed.',
          },
        ],
      }),
    },
    { onSubmit: this._applyDiscount.bind(this) as () => Promise<void> },
  );

  public get ratesOverrideData(): RatesOverride[] {
    return this.rateForms.map((rateForm) => rateForm.ratesOverrideData);
  }

  private _applyDiscount(): void {
    runInAction(() => {
      if (this.discountForm.fields.discount.value > 0) {
        this.rateForms.forEach((rateForm) => {
          rateForm.applyDiscount(Number(this.discountForm.fields.discount.value));
        });
      }
    });
  }

  public restoreInitialRates(): void {
    this.rateForms.forEach((rateForm) => {
      rateForm.resetToInitialRates();
    });
  }

  constructor(props: RatesOverriderDelegateProps) {
    this.rateForms = props.products.map((product) => new ProductRatesForm(product));

    makeObservable<RatesOverriderDelegate, '_applyDiscount'>(this, {
      rateForms: observable,
      discountForm: observable,
      _applyDiscount: action.bound,
      restoreInitialRates: action.bound,
      ratesOverrideData: computed,
    });
  }
}
